import { render, staticRenderFns } from "./ListFinalDocs.vue?vue&type=template&id=6240eeb9&scoped=true&"
import script from "./ListFinalDocs.vue?vue&type=script&lang=js&"
export * from "./ListFinalDocs.vue?vue&type=script&lang=js&"
import style0 from "./ListFinalDocs.vue?vue&type=style&index=0&id=6240eeb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6240eeb9",
  null
  
)

export default component.exports